module.exports = __webpack_public_path__ + "img/foot.25d87352.png";